// extracted by mini-css-extract-plugin
export default {"users-avatar":"Avatar_users-avatar__pz5iq","avatar-null":"Avatar_avatar-null__z8Ip+","name":"Avatar_name__BFIKW"};